import type { NextPage } from 'next';
import { Page as Component } from '~/containers/specifics/vendors/settings/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/vendors/settings';

const Home: NextPage = () => (
  <>
    <NskHead title="設定" />
    <Component />
  </>
);

export default Home;
